import FieldController from '../field.controller';
import { isDateObject } from '../../../../../../lib/util';
import { castToBoolean } from '../../../../../../lib/util';
import angular from 'angular';

class DateTimeFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, DateTimeService) {
    "ngInject";
    super($scope, $q, $translate, $log);
    this.DateTimeService = DateTimeService;
    this._datePickerOpened = false;
    this._datePickerOptions = {
    };
  }

  $onInit() {
    this.dateValue = this.value;
  }

  get datePickerOptions() {
    return this._datePickerOptions;
  }

  get datePickerOpened() {
    return this._datePickerOpened;
  }

  set datePickerOpened(opened) {
    this._datePickerOpened = opened;
  }

  get dateValue() {
    return this.value;
  }

  set dateValue(dateValue) {
    // TODO: Determine whether this should be parsed in local time, server time, or event time
    this.value = this.DateTimeService.parseDate(dateValue);
  }

  get required() {
    return this.field && castToBoolean(this.field.required);
  }

  get editable() {
    if (this.field.editable) {
      return castToBoolean(this.field.editable);
    }
    return false;
  }

  openDatePicker() {
    this.datePickerOpened = true;
  }
}

export default DateTimeFieldController;
